module.exports = __webpack_public_path__ + "static/img/15.d110423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/15.png
// module id = H3fN
// module chunks = 0